module.exports = __webpack_public_path__ + "img/setting-step-three2.02a71911.png";